import React, { useState, useEffect, useMemo } from 'react';
import { FaUnlink } from 'react-icons/fa';
import { Col, Row } from 'react-bootstrap';
import api from 'services/api';
import Card from 'v3/components/Card';
import Text from 'v3/components/Text';
import Button from 'v3/components/Button';
import Fallback from 'v3/components/Fallback';
import DataTable from 'v3/components/DataTable';
import theme from 'v3/theme';
import { useUser } from './context';
import AddBeneficiary from './Modals/AddBeneficiary';

const userDetailsTableStyles = {
  borderCollapse: 'collapse',
  '> thead > tr > th': {
    borderBottom: '1px solid #E5E7EB',
  },
  '> thead > tr > th:last-child': {
    textAlign: 'right',
    paddingRight: '24px',
  },
  '> tbody > tr': {
    borderBottom: '1px solid #E5E7EB',
  },
  '> tbody > tr > td:last-child': {
    textAlign: 'right',
    paddingRight: '24px',
  },
  '> tbody > tr:hover': {
    background: '#F5F6F8',
  },
  '> tbody > tr:hover > td': {
    background: '#F5F6F8',
  },
};

export default function Beneficiary() {
  const user = useUser();
  const [show, setShow] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  const isEditing = useMemo(() => {
    return !!user.data?.id;
  }, [user.data?.id]);

  function handleDeleteShipper(beneficiaryId) {
    user.setData({
      beneficiary: user.data?.beneficiary.filter((shipper) => shipper.id !== beneficiaryId),
    });
  }

  async function handleDettachShipper(beneficiaryId) {
    try {
      setLoading(true);
      await api.delete(`v3/user/${user.data.id}/shipping-company/${beneficiaryId}`);

      user.setData({
        beneficiary: user.data?.beneficiary.filter((shipper) => shipper.id !== beneficiaryId),
      });
    } catch (error) {
      user.showSnackbar('Erro ao excluir transportadora', { type: 'error' });
    } finally {
      setLoading(false);
    }
  }

  function handleRemoveShipper(beneficiaryId) {
    if (isEditing) handleDettachShipper(beneficiaryId);
    else handleDeleteShipper(beneficiaryId);
  }

  const shippingCompaniesDataTable = useMemo(() => {
    const offset = (page - 1) * perPage;
    const shipper = user.data?.beneficiary
      ?.filter(
        (item) =>
          item.social_name.toLowerCase().includes(search.toLowerCase()) ||
          item.cgccpf.includes(search),
      )
      .slice(offset, perPage + offset);
    if (shipper?.length === 0 && page > 1) setPage(page - 1);
    return shipper;
  }, [user.data?.beneficiary, page, perPage, search]);

  return (
    <>
      <AddBeneficiary isOpen={show} onClose={() => setShow(false)} />
      <Card
        loading={user.isFetching}
        header={
          <Text type="header" color="dark">
            Beneficiários
          </Text>
        }
        HeaderRightComponent={
          <>
            {!!user.data?.beneficiary?.length && (
              <Button
                disabled={!user.hasPermissionToEdit}
                onClick={() => {
                  user.updatePrevUser();
                  setShow(true);
                }}
              >
                <Text type="regular" weight="500" color="white">
                  Adicionar
                </Text>
              </Button>
            )}
          </>
        }
      >
        <Row>
          <Fallback
            fall={!user.data?.beneficiary?.length}
            component={
              <Col xs={12} className="align-items-center d-flex flex-column my-2">
                <Text color={theme.colors.dark}>Não há beneficiário nesse usuário.</Text>
                <Button
                  className="mt-4"
                  onClick={() => {
                    user.updatePrevUser();
                    setShow(true);
                  }}
                  disabled={!user.hasPermissionToEdit}
                >
                  <Text type="regular" weight="500" color="white">
                    Adicionar
                  </Text>
                </Button>
              </Col>
            }
          >
            <Col>
              <DataTable
                data={shippingCompaniesDataTable}
                total={user.data?.beneficiary?.length}
                pages={Math.ceil(user.data?.beneficiary?.length / perPage)}
                currentPage={page}
                onPageChanged={setPage}
                onSearchChanged={setSearch}
                onPerPageChanged={(v) => setPerPage(+v)}
                loading={loading}
                searchPlaceholder="CNPJ ou Razão social"
                tableStyles={userDetailsTableStyles}
                columns={[
                  {
                    name: 'Beneficiários',
                    selector: (row) => row?.social_name,
                  },
                  { name: 'CPF/CNPJ', selector: (row) => row?.cgccpf },
                  {
                    name: 'Ação',
                    render: (row) => (
                      <Button
                        variant="error"
                        size="sm"
                        className="mx-1"
                        onClick={() => handleRemoveShipper(row.id)}
                        disabled={!user.hasPermissionToEdit}
                      >
                        <FaUnlink />
                      </Button>
                    ),
                  },
                ]}
              />
            </Col>
          </Fallback>
        </Row>
      </Card>
    </>
  );
}
